<template>
  <div>
    <session-view
        v-if="isAuthToJoinRoom"
        :profile="profile"
        :session="session"
        :room-data="roomData"
        :av-resources="avResources"
    />
    <sessions-preview
        v-else
        v-observe-visibility="visibiltyCheck"
        :profile="profile"
        :session="session"
        :stage-room-id="stageRoomId"
        :is-room-avail="isRoomAvail"
        :is-av-set-up="isAVSetUp"
        @set-up-room="handleSetUpRoom"
        @update-status="handleUpdateStatus"
        @join-room="handleJoinRoom"
        @change-role="handleChangeRoleTo"
    />
    <session-status
        v-if="!production"
        :session="session"
        :profile="profile"
        :session-status="status"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";
import Vue from "vue";
import { getDevices } from "@vonage/video-express";
import SessionStatus from "./status";
import SessionView from "./sessionView"
import SessionsPreview from "./sessionPreView";
import VueObserveVisibility from "vue-observe-visibility";
Vue.use(VueObserveVisibility);

export default {
  name: "Sessions_Sidebar_Session_Body",
  components: {
    SessionView,
    SessionsPreview,
    SessionStatus
  },
  props: {
    session: {
      type: Object,
      default: () => {
        return {};
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    roomRole: {
      type: String,
      default: 'viewer'   //viewer | host | speaker | admin
    },
    roomManagementMode: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({}),
    isRoomAvail(){
      return  !!(this.roomData.apiKey && this.roomData.sessionId);
    },
    isAVSetUp(){
      return !!(this.avResources.selectedAudio && this.avResources.selectedVideo);
    },
    isAuthToJoinRoom(){
      return !!this.roomData.token;
    },
  },
  methods: {
    handleChangeRoleTo(newRole){
      this.roomData.role = newRole;
    },
    hasPermissionFor(permittedRole){
      return this.role == permittedRole;
    },
    handleUpdateStatus({key, value}){
      this.status[key]=value;
    },
    handleSettingsPopOverClick(){
      this.showMenuPopover = !this.showMenuPopover;
    },
    handleAddDataButtonClick() {
      this.$emit('add-data-click');
    },
    handleSetUpRoom() {
      this.handleCreateRoom()
          .then((resp1)=> {
            console.log(resp1);
            this.handleAVRequestAccess()
                .then((resp2) => {
                  console.log(resp2);
                  if(resp2 && this.avResources.selectedVideo && this.avResources.selectedAudio)  {
                    console.log('made it here');
                  }
                }).catch((err)=>{
              console.error('Error');
            });
          })
          .catch((err)=>{
            console.error(`Not able to create room: ${JSON.stringify(err)}`)
          });
    },
    handleCreateRoom() {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        this.roomRef = db.doc(`rooms/${this.stageRoomId}`);
        console.log("Room name: ", this.stageRoomId);
        this.status.roomStatus = "Creating the room...";
        return this.roomRef
            .get()
            .then(doc => {
              if (doc.exists) {
                this.roomRef
                    .update({
                      _updated_at: new Date()
                    })
                    .then(() => {
                      this.status.roomStatus = `Room Exists!`;
                      return this.subscribeToRoom(this.stageRoomId)
                          .then((resp)=>{
                            res (resp);
                          }).catch((err)=>{
                            rej(err);
                          })
                    });
              } else {
                this.roomRef
                    .set({
                      _created_at: new Date(),
                      apiKey: "",
                      sessionId: ""
                    })
                    .then(() => {
                      this.status.roomStatus = `Room Created!`;
                      return this.subscribeToRoom(this.stageRoomId)
                          .then((resp)=>{
                            res (resp);
                          }).catch((err)=>{
                            rej(err);
                          })
                    });
              }
            })
            .catch(error => {
              console.error("Error creating room: ", error);
              this.status.roomStatus = "Error creating room!";
            });
      });
    },
    subscribeToRoom() {
      return new Promise((res, rej) => {
        this.unsubRoom = this.roomRef.onSnapshot(doc => {
          let data = doc.data();
          console.log("Room Subscription Data: ", data);

          if (data.apiKey !== "" && data.sessionId !== "") { //this take time to create- bottle neck
            //Set Data
            this.roomData.apiKey = data.apiKey;
            this.roomData.sessionId = data.sessionId;
            this.status.roomStatus = `Room Subsribed To!`;
            res(this.roomData)
          } else {
            rej({error:'Room does not exist'});
          }

        });
      })
    },
    async handleAVRequestAccess() {
      let resourcesLoaded = await this.loadAVSource();
      return new Promise((res, rej) => {
        if (resourcesLoaded) {
          res(true);
        } else {
          rej(false);
        }
      });
    },
    async loadAVSource() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        console.log("enumerateDevices() not supported.");
        return;
      }
      try {
        // Need to ask permission in order to get access to the devices to be able to list them in the dropdowns.
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true
        });
        stream.getTracks().forEach(track => track.stop());
        let audioCount = 0;
        let videoCount = 0;
        const devices = await getDevices();

        devices.forEach(device => {
          if (device.kind.toLowerCase() === "audioinput") {
            audioCount++;

            let optAudio = {
              text: device.label || ` ${device.kind}  ${audioCount}`,
              value: device.deviceId
            };
            this.avResources.optsAudio.push(optAudio);
          }

          if (device.kind.toLowerCase() === "videoinput") {
            videoCount++;
            let optVideo = {
              text: device.label || ` ${device.kind}  ${videoCount}`,
              value: device.deviceId
            };
            this.avResources.optsVideo.push(optVideo);
          }
        });

        //Set Default Source
        this.avResources.selectedAudio =
            this.avResources.optsAudio &&
            Array.isArray(this.avResources.optsAudio) &&
            this.avResources.optsAudio.length > 0 &&
            this.avResources.optsAudio[0] &&
            this.avResources.optsAudio[0].value
                ? this.avResources.optsAudio[0].value
                : null;
        this.avResources.selectedVideo =
            this.avResources.optsVideo &&
            Array.isArray(this.avResources.optsVideo) &&
            this.avResources.optsVideo.length > 0 &&
            this.avResources.optsVideo[0] &&
            this.avResources.optsVideo[0].value
                ? this.avResources.optsVideo[0].value
                : null;
        return true;
      } catch (error) {
        console.error("error loading AV sources: ", error);
      }
      return false;
    },
    /**** JOIN ROOM DB**/
    handleJoinRoom() {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //@TODO-Move to single place
        this.participantRef = db.doc(
            `rooms/${this.stageRoomId}/participants/${this.participantName}`
        );

        return this.participantRef
            .get()
            .then(doc => {
              if (doc.exists) {
                this.participantRef
                    .update({
                      _updated_at: new Date()
                    })
                    .then(() => {
                      return this.subscribeToParticipant(this.stageRoomId).then((resp)=>{
                        res(resp);
                      }).catch((err)=>{
                        rej(err);
                      });
                    });
              } else {
                this.participantRef
                    .set({
                      _created_at: new Date(),
                      token: ""
                    })
                    .then(() => {
                      return this.subscribeToParticipant(this.stageRoomId).then((resp)=>{
                        res(resp);
                      }).catch((err)=>{
                        rej(err);
                      });
                    });
              }
            })
            .catch(err => {
              console.error("Error joining participant: ", err);
              rej(err);
            });
      });
    },
    subscribeToParticipant() { //unsubP- @Todo- need different subscriptions?
      return new Promise((res, rej) => {
        this.unsubUser = this.participantRef.onSnapshot(doc => {
          let data = doc.data();
          console.log("Current data: ", data);
          if (data.token !== "") {
            this.roomData.token = data.token;
            //Not connected here
            if (this.avResources.previewPublisher) {
              this.avResources.previewPublisher.destroy();
            }
          }
        });
        res(true);
      });
    },
    visibiltyCheck(isVisible, entry) {
      if (isVisible) {
        this.handleSetUpRoom();
      }
    },
    handleLeaveRoom() {},
  },
  data() {
    return {
      production: true,
      roomData: {
        apiKey: null,
        sessionId: null,
        token: null,
        participantName: this.profile && this.profile.firstname ? this.profile.firstname : null,
        role: this.roomRole,
        managementMode: this.roomManagementMode
      },
      avResources:{
        optsAudio: [],
        optsVideo: [],
        selectedAudio: null,
        selectedVideo: null,
        previewPublisher: null
      },
      showMenuPopover: false,
      screen: {
        bgColor: "#222222"
      },
      room: null,
      roomRef: "",
      participantRef: "",
      stageRoomId: this.session && this.session.id ? this.session.id : null,
      toggle: {
        showSettings: false
      },
      status: {
        isVideoEnabled: null,
        isAudioEnabled: null,
        roomStatus: null,
        layoutStatus: "",
      },
      camera: null,
      unsubRoom: null,
      unsubUser: null,
      publisher: null
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
